/* ===========================================================================
   Gel-Sitzkissen – XELAE  ·  logique de la fiche (offres, panier, UI)
   Aucun prix en dur : tout provient de #gs-config, alimente par Liquid
   depuis le VRAI produit Shopify et ses variantes.
   Namespace global unique : window.gelSitzkissen
   =========================================================================== */
(function () {
  'use strict';

  var CFG = null;
  try {
    var el = document.getElementById('gs-config');
    if (el) CFG = JSON.parse(el.textContent);
  } catch (e) { /* noop */ }
  if (!CFG) CFG = { offers: [], gift: null, upsell: null, money: '{{amount}} €', strings: {} };

  var S = CFG.strings || {};
  function t(k, fallback) { return S[k] || fallback; }

  /* --------------------------------------------------------------- helpers */
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v + ' €';
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  function decodeEntities(s) {
    var d = document.createElement('textarea');
    d.innerHTML = String(s == null ? '' : s);
    return d.value;
  }
  function api(url, opts) {
    return fetch(url, Object.assign({
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin'
    }, opts || {})).then(function (r) {
      if (!r.ok) return r.text().then(function (txt) { throw new Error(txt || r.status); });
      return r.json();
    });
  }
  function imgUrl(url, w) {
    if (!url) return '';
    if (url.indexOf('cdn.shopify.com') === -1 && url.indexOf('/cdn/') === -1) return url;
    return url.replace(/(\.(png|jpe?g|webp|gif))(\?|$)/i, '_' + w + 'x$1$3');
  }

  /* ================================================================ OFFRES */
  var selectedOfferId = null;

  function currentOffer() {
    var o = null;
    (CFG.offers || []).forEach(function (x) { if (x.id === selectedOfferId) o = x; });
    return o || (CFG.offers || [])[0] || null;
  }

  function initOffers() {
    var bars = $$('[data-gs-offer]');
    if (!bars.length) return;

    function select(id, focus) {
      selectedOfferId = id;
      bars.forEach(function (bar) {
        var on = bar.getAttribute('data-gs-offer') === id;
        bar.classList.toggle('is-selected', on);
        var input = $('input[type=radio]', bar);
        if (input) input.checked = on;
        bar.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var o = currentOffer();
      $$('[data-gs-atc]').forEach(function (b) {
        if (o) b.setAttribute('data-variant-id', o.variantId);
      });
      document.dispatchEvent(new CustomEvent('gs:offer-changed', { detail: o }));
      if (focus) { /* pas de scroll force */ }
    }

    bars.forEach(function (bar) {
      var id = bar.getAttribute('data-gs-offer');
      bar.addEventListener('click', function (ev) {
        if (ev.target.closest('a')) return;   // liens cadeaux : nouvel onglet
        select(id, true);
      });
      bar.addEventListener('keydown', function (ev) {
        if (ev.key === ' ' || ev.key === 'Enter') { ev.preventDefault(); select(id, true); }
      });
    });

    var pre = null;
    bars.forEach(function (b) { if (b.hasAttribute('data-gs-preselected')) pre = b.getAttribute('data-gs-offer'); });
    select(pre || bars[0].getAttribute('data-gs-offer'), false);
  }

  /* ============================================================== COMPTEURS */
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* compte a rebours "Endet in HH:MM:SS" -> minuit local */
  function initMidnightTimers() {
    var nodes = $$('[data-gs-midnight]');
    if (!nodes.length) return;
    function tick() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var txt = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
      nodes.forEach(function (n) { n.textContent = txt; });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* reservation panier : 10:00 decroissant, persiste dans sessionStorage */
  function initReservationTimer() {
    var KEY = 'gs-reserve-until';
    function ensure() {
      var v = parseInt(sessionStorage.getItem(KEY) || '0', 10);
      if (!v || v < Date.now()) { v = Date.now() + 10 * 60 * 1000; sessionStorage.setItem(KEY, String(v)); }
      return v;
    }
    function tick() {
      var nodes = $$('[data-gs-reserve]');
      if (!nodes.length) return;
      var s = Math.max(0, Math.floor((ensure() - Date.now()) / 1000));
      var txt = pad(Math.floor(s / 60)) + ':' + pad(s % 60);
      nodes.forEach(function (n) { n.textContent = txt; });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ================================================================ PANIER */
  var cartState = null;
  var busy = false;

  function offerForVariant(vid) {
    var found = null;
    (CFG.offers || []).forEach(function (o) { if (String(o.variantId) === String(vid)) found = o; });
    return found;
  }

  function addToCart(variantId, qty) {
    var offer = offerForVariant(variantId);
    var items = [{ id: Number(variantId), quantity: qty || 1 }];
    if (offer && offer.giftQty && CFG.gift && CFG.gift.variantId) {
      items.push({
        id: Number(CFG.gift.variantId),
        quantity: offer.giftQty * (qty || 1),
        properties: { '_gs_gift': offer.id }
      });
    }
    return api('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: items }) })
      .then(refreshCart);
  }

  function refreshCart() {
    return api('/cart.js').then(function (c) { cartState = c; renderCart(); updateBubbles(); return c; });
  }

  function changeLine(key, quantity) {
    if (busy) return Promise.resolve();
    busy = true;
    return api('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: quantity }) })
      .then(function (c) { cartState = c; return reconcileGifts(); })
      .then(function () { renderCart(); updateBubbles(); })
      .catch(function (e) { console.error('[gs] change', e); })
      .then(function () { busy = false; });
  }

  /* Les cadeaux suivent toujours la quantite de packs achetee. */
  function reconcileGifts() {
    if (!CFG.gift || !CFG.gift.variantId || !cartState) return Promise.resolve(cartState);
    var wanted = 0;
    cartState.items.forEach(function (it) {
      var o = offerForVariant(it.variant_id);
      if (o && o.giftQty) wanted += o.giftQty * it.quantity;
    });
    var giftLine = null;
    cartState.items.forEach(function (it) {
      if (String(it.variant_id) === String(CFG.gift.variantId)) giftLine = it;
    });
    var have = giftLine ? giftLine.quantity : 0;
    if (have === wanted) return Promise.resolve(cartState);

    if (giftLine) {
      return api('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: giftLine.key, quantity: wanted }) })
        .then(function (c) { cartState = c; return c; });
    }
    if (wanted > 0) {
      return api('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ items: [{ id: Number(CFG.gift.variantId), quantity: wanted, properties: { '_gs_gift': '1' } }] })
      }).then(function () { return api('/cart.js'); }).then(function (c) { cartState = c; return c; });
    }
    return Promise.resolve(cartState);
  }

  function updateBubbles() {
    var n = cartState ? cartState.item_count : 0;
    $$('[data-gs-cart-count]').forEach(function (e) {
      e.textContent = n;
      e.style.display = n > 0 ? '' : 'none';
    });
  }

  /* ------------------------------------------------------------ rendu HTML */
  function lineIsGift(it) {
    return it.final_price === 0 || (CFG.gift && String(it.variant_id) === String(CFG.gift.variantId));
  }

  /* Prix de reference d'une ligne (le prix barre).
     On prefere la valeur reelle de Shopify (original_line_price) ; si la vitrine
     n'expose pas de compare-at, on retombe sur la reference declaree dans #gs-config. */
  function lineReference(it) {
    var offer = offerForVariant(it.variant_id);
    var unit = 0;
    if (offer && offer.compareAt) unit = offer.compareAt;
    else if (lineIsGift(it) && CFG.gift && CFG.gift.compareAt) unit = CFG.gift.compareAt;
    var declared = unit * it.quantity;
    var real = it.original_line_price || 0;
    return Math.max(declared, real);
  }

  function renderCart() {
    var body = $('[data-gs-cart-items]');
    var foot = $('[data-gs-cart-foot]');
    if (!body) return;

    if (!cartState || !cartState.items.length) {
      body.innerHTML =
        '<div class="gs-cart__empty">' +
          '<p>' + esc(t('cart_empty', 'Ihr Warenkorb ist noch leer.')) + '</p>' +
          '<button type="button" class="gs-btn" data-gs-cart-close>' +
            esc(t('cart_continue', 'Weiter einkaufen')) + '</button>' +
        '</div>';
      if (foot) foot.hidden = true;
      var rb = $('[data-gs-reserve-bar]'); if (rb) rb.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    var rb2 = $('[data-gs-reserve-bar]'); if (rb2) rb2.hidden = false;

    var mains = [], gifts = [];
    cartState.items.forEach(function (it) { (lineIsGift(it) ? gifts : mains).push(it); });

    // La ligne « porteuse » des cadeaux est celle de l'offre (le produit principal),
    // pas simplement la premiere ligne du panier : sinon l'upsell paye herite des cadeaux.
    var hostIndex = -1;
    mains.forEach(function (it, i) {
      if (hostIndex === -1 && offerForVariant(it.variant_id)) hostIndex = i;
    });
    if (hostIndex === -1 && mains.length) hostIndex = 0;

    var html = '';
    mains.forEach(function (it, i) {
      html += lineHTML(it, false);
      if (i === hostIndex) {
        gifts.forEach(function (g) { html += lineHTML(g, true); });
        gifts = [];
      }
    });
    gifts.forEach(function (g) { html += lineHTML(g, true); });
    body.innerHTML = html;

    renderFooter();
  }

  function lineHTML(it, isGift) {
    var offer = offerForVariant(it.variant_id);
    var units = offer && offer.units ? offer.units : 1;
    var shownQty = it.quantity * units;
    var title = decodeEntities(it.product_title || it.title);
    var prefix = shownQty > 1 ? shownQty + 'x ' : '';
    var img = it.image ? imgUrl(it.image, 200) : '';

    var ref = lineReference(it);
    var priceHTML;
    if (isGift || it.final_line_price === 0) {
      priceHTML =
        (ref > 0 ? '<span class="gs-cart__old">' + money(ref) + '</span>' : '') +
        '<span class="gs-cart__free">' + esc(t('free', 'GRATIS')) + '</span>';
    } else {
      priceHTML =
        (ref > it.final_line_price
          ? '<span class="gs-cart__old">' + money(ref) + '</span>' : '') +
        '<span class="gs-cart__now">' + money(it.final_line_price) + '</span>';
    }

    return '' +
      '<div class="gs-cart__line' + (isGift ? ' gs-cart__line--gift' : '') + '" data-key="' + esc(it.key) + '">' +
        (isGift ? '<span class="gs-cart__hook" aria-hidden="true">&#8627;</span>' : '') +
        '<div class="gs-cart__thumb">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(title) + '" width="80" height="80" loading="lazy">' : '') +
          (units > 1 && !isGift ? '<span class="gs-cart__badge">X' + units + '</span>' : '') +
        '</div>' +
        '<div class="gs-cart__main">' +
          '<p class="gs-cart__title">' + esc(prefix + title) + '</p>' +
          '<div class="gs-cart__qty' + (isGift ? ' is-locked' : '') + '">' +
            '<button type="button" data-gs-qty="-1" ' + (isGift ? 'disabled' : '') +
              ' aria-label="' + esc(t('qty_minus', 'Menge verringern')) + '">&minus;</button>' +
            '<span>' + shownQty + '</span>' +
            '<button type="button" data-gs-qty="1" ' + (isGift ? 'disabled' : '') +
              ' aria-label="' + esc(t('qty_plus', 'Menge erhöhen')) + '">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="gs-cart__right">' +
          '<div class="gs-cart__prices">' + priceHTML + '</div>' +
          '<button type="button" class="gs-cart__remove" data-gs-remove ' +
            'aria-label="' + esc(t('remove', 'Entfernen')) + '">' +
            '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
            '<polyline points="3 6 5 6 21 6"></polyline>' +
            '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>' +
            '<line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>' +
            '</svg>' +
          '</button>' +
        '</div>' +
      '</div>';
  }

  function renderFooter() {
    var save = $('[data-gs-savings]');
    var total = $('[data-gs-total]');
    if (total) total.textContent = money(cartState.total_price);
    if (save) {
      var refTotal = 0;
      (cartState.items || []).forEach(function (it) { refTotal += lineReference(it); });
      var d = Math.max(
        cartState.total_discount || 0,
        (cartState.original_total_price || 0) - cartState.total_price,
        refTotal - cartState.total_price
      );
      if (d > 0) {
        save.hidden = false;
        var lbl = $('[data-gs-savings-label]', save);
        var amt = $('[data-gs-savings-amount]', save);
        var title = '';
        (cartState.items || []).forEach(function (it) {
          if (!title && it.discounts && it.discounts.length) title = it.discounts[0].title;
        });
        if (!title) {
          var o = currentOffer();
          title = (o && o.title) || t('savings', 'Rabatt');
        }
        if (lbl) lbl.textContent = decodeEntities(title);
        if (amt) amt.textContent = '-' + money(d);
      } else {
        save.hidden = true;
      }
    }
    // upsell : coche si deja au panier
    var up = $('[data-gs-upsell]');
    if (up && CFG.upsell) {
      var present = false;
      (cartState.items || []).forEach(function (it) {
        if (String(it.variant_id) === String(CFG.upsell.variantId)) present = true;
      });
      up.classList.toggle('is-on', present);
      var sw = $('[data-gs-upsell-toggle]', up);
      if (sw) sw.setAttribute('aria-checked', present ? 'true' : 'false');
    }
  }

  /* --------------------------------------------------------------- drawer */
  var lastFocus = null;

  function openCart() {
    var d = $('[data-gs-cart]');
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.body.classList.add('gs-noscroll');
    var c = $('[data-gs-cart-close]', d);
    if (c) c.focus();
  }
  function closeCart() {
    var d = $('[data-gs-cart]');
    if (!d) return;
    d.classList.remove('is-open');
    document.body.classList.remove('gs-noscroll');
    setTimeout(function () { d.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function initCart() {
    var drawer = $('[data-gs-cart]');
    if (!drawer) return;

    document.addEventListener('click', function (ev) {
      var open = ev.target.closest('[data-gs-cart-open]');
      if (open) { ev.preventDefault(); refreshCart().then(openCart); return; }

      if (ev.target.closest('[data-gs-cart-close]') || ev.target.closest('[data-gs-cart-overlay]')) {
        ev.preventDefault(); closeCart(); return;
      }

      var atc = ev.target.closest('[data-gs-atc]');
      if (atc) {
        ev.preventDefault();
        if (atc.classList.contains('is-loading')) return;
        atc.classList.add('is-loading');
        var vid = atc.getAttribute('data-variant-id') || (currentOffer() || {}).variantId;
        addToCart(vid, 1)
          .then(openCart)
          .catch(function (e) { console.error('[gs] add', e); alert(t('add_error', 'Der Artikel konnte nicht hinzugefügt werden.')); })
          .then(function () { atc.classList.remove('is-loading'); });
        return;
      }

      var q = ev.target.closest('[data-gs-qty]');
      if (q) {
        ev.preventDefault();
        var line = q.closest('[data-key]');
        if (!line) return;
        var key = line.getAttribute('data-key');
        var item = null;
        (cartState.items || []).forEach(function (it) { if (it.key === key) item = it; });
        if (!item) return;
        var delta = parseInt(q.getAttribute('data-gs-qty'), 10);
        changeLine(key, Math.max(0, item.quantity + delta));
        return;
      }

      var rm = ev.target.closest('[data-gs-remove]');
      if (rm) {
        ev.preventDefault();
        var l2 = rm.closest('[data-key]');
        if (l2) changeLine(l2.getAttribute('data-key'), 0);
        return;
      }

      var upsell = ev.target.closest('[data-gs-upsell-toggle]');
      if (upsell && CFG.upsell) {
        ev.preventDefault();
        var wrap = upsell.closest('[data-gs-upsell]');
        var on = wrap && wrap.classList.contains('is-on');
        if (on) {
          var k = null;
          (cartState.items || []).forEach(function (it) {
            if (String(it.variant_id) === String(CFG.upsell.variantId)) k = it.key;
          });
          if (k) changeLine(k, 0);
        } else {
          busy = true;
          api('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: Number(CFG.upsell.variantId), quantity: 1 }] }) })
            .then(refreshCart)
            .catch(function (e) { console.error('[gs] upsell', e); })
            .then(function () { busy = false; });
        }
        return;
      }

      var co = ev.target.closest('[data-gs-checkout]');
      if (co) {
        ev.preventDefault();
        co.classList.add('is-loading');
        /* Le checkout suit le CHEMIN de l'URL, pas l'IP du visiteur.
           1) si le visiteur est deja sous un prefixe de marche (/de-de, /en-us...),
              on le conserve : marche ET langue restent les siens ;
           2) sinon on applique le prefixe configure dans la section.
           Sans cela, un `/checkout` absolu ramene au marche du domaine racine. */
        var here = (location.pathname.match(/^\/[a-z]{2}-[a-z]{2}(?=\/|$)/i) || [''])[0];
        var mp = (here || CFG.marketPath || '').replace(/\/$/, '');
        window.location.href = mp + '/checkout';
      }
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && drawer.classList.contains('is-open')) closeCart();
    });

    refreshCart();
  }

  /* ================================================================== UI+ */
  function initAccordions() {
    $$('[data-gs-acc]').forEach(function (acc) {
      var head = $('[data-gs-acc-head]', acc);
      var panel = $('[data-gs-acc-panel]', acc);
      if (!head || !panel) return;
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      function toggle() {
        var open = acc.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '';
      }
      head.addEventListener('click', toggle);
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
      if (acc.classList.contains('is-open')) panel.style.maxHeight = panel.scrollHeight + 'px';
    });
  }

  function initTabs() {
    $$('[data-gs-tabs]').forEach(function (wrap) {
      var tabs = $$('[data-gs-tab]', wrap);
      var panels = $$('[data-gs-tabpanel]', wrap);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var name = tab.getAttribute('data-gs-tab');
          tabs.forEach(function (x) {
            var on = x === tab;
            x.classList.toggle('is-active', on);
            x.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.hidden = p.getAttribute('data-gs-tabpanel') !== name;
          });
        });
      });
    });
  }

  /* carrousel simple : scroll-snap + fleches + points, swipe natif */
  function initCarousels() {
    $$('[data-gs-carousel]').forEach(function (root) {
      var track = $('[data-gs-track]', root);
      if (!track) return;
      var prev = $('[data-gs-prev]', root);
      var next = $('[data-gs-next]', root);
      var dots = $$('[data-gs-dot]', root);

      function slides() { return $$('[data-gs-slide]', track); }
      function index() {
        var s = slides(); if (!s.length) return 0;
        var c = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bd = Infinity;
        s.forEach(function (el, i) {
          var m = el.offsetLeft + el.offsetWidth / 2;
          var d = Math.abs(m - c);
          if (d < bd) { bd = d; best = i; }
        });
        return best;
      }
      function go(i) {
        var s = slides(); if (!s.length) return;
        i = Math.max(0, Math.min(s.length - 1, i));
        track.scrollTo({ left: s[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      function sync() {
        var i = index();
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides().length - 1;
      }
      if (prev) prev.addEventListener('click', function () { go(index() - 1); });
      if (next) next.addEventListener('click', function () { go(index() + 1); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      track.addEventListener('scroll', function () {
        clearTimeout(track.__t); track.__t = setTimeout(sync, 90);
      }, { passive: true });
      sync();
    });
  }

  /* galerie produit : vignettes + fleches + points, synchronises */
  function initGallery() {
    var root = $('[data-gs-gallery]');
    if (!root) return;
    var track = $('[data-gs-gallery-track]', root);
    var thumbs = $$('[data-gs-thumb]', root);
    var dots = $$('[data-gs-gdot]', root);
    var prev = $('[data-gs-gprev]', root);
    var next = $('[data-gs-gnext]', root);
    if (!track) return;

    function slides() { return $$('[data-gs-gslide]', track); }
    function index() {
      var s = slides(); if (!s.length) return 0;
      var c = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bd = Infinity;
      s.forEach(function (el, i) {
        var m = el.offsetLeft + el.offsetWidth / 2;
        var d = Math.abs(m - c); if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    function go(i) {
      var s = slides(); if (!s.length) return;
      i = Math.max(0, Math.min(s.length - 1, i));
      track.scrollTo({ left: s[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function sync() {
      var i = index();
      thumbs.forEach(function (x, k) { x.classList.toggle('is-active', k === i); });
      dots.forEach(function (x, k) { x.classList.toggle('is-active', k === i); });
    }
    thumbs.forEach(function (x, k) { x.addEventListener('click', function () { go(k); }); });
    dots.forEach(function (x, k) { x.addEventListener('click', function () { go(k); }); });
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    track.addEventListener('scroll', function () {
      clearTimeout(track.__g); track.__g = setTimeout(sync, 90);
    }, { passive: true });
    sync();
  }

  function initMobileMenu() {
    var btn = $('[data-gs-menu-open]');
    var panel = $('[data-gs-menu]');
    if (!btn || !panel) return;
    function close() {
      panel.classList.remove('is-open');
      document.body.classList.remove('gs-noscroll');
      btn.setAttribute('aria-expanded', 'false');
      setTimeout(function () { panel.hidden = true; }, 240);
    }
    btn.addEventListener('click', function () {
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      document.body.classList.add('gs-noscroll');
      btn.setAttribute('aria-expanded', 'true');
    });
    panel.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-gs-menu-close]') || ev.target.closest('a')) close();
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && panel.classList.contains('is-open')) close();
    });
  }

  /* dates de livraison dynamiques : Bestellt / Versandt / Geliefert */
  function initDeliveryDates() {
    var nodes = $$('[data-gs-date]');
    if (!nodes.length) return;
    var MONTHS = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];
    function fmt(d) { return ('0' + d.getDate()).slice(-2) + '. ' + MONTHS[d.getMonth()]; }
    function plus(n) { var d = new Date(); d.setDate(d.getDate() + n); return d; }
    nodes.forEach(function (n) {
      var spec = n.getAttribute('data-gs-date');
      var parts = spec.split('-').map(function (x) { return parseInt(x, 10); });
      n.textContent = parts.length === 2
        ? fmt(plus(parts[0])) + ' – ' + fmt(plus(parts[1]))
        : fmt(plus(parts[0]));
    });
  }

  /* ================================================================== boot */
  function boot() {
    initOffers();
    initMidnightTimers();
    initReservationTimer();
    initCart();
    initAccordions();
    initTabs();
    initCarousels();
    initGallery();
    initMobileMenu();
    initDeliveryDates();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.gelSitzkissen = {
    open: openCart, close: closeCart, refresh: refreshCart,
    add: addToCart, config: CFG, state: function () { return cartState; }
  };
})();
